import AUFunctions from "modules/addons/components/digital-onboarding/PPSRRegistration/forms/PPSRFunctions/AUFunctions";
import NZFunctions from "modules/addons/components/digital-onboarding/PPSRRegistration/forms/PPSRFunctions/NZFunctions";

export { AUFunctions };
export { NZFunctions };
